module.exports = __webpack_public_path__ + "img/SentimentVerySatisfiedOutlined.50d32050.svg";